export const analyticListSelector = (state) => state.analytic.analyticList;
